import { render, staticRenderFns } from "./Screenshots.vue?vue&type=template&id=2d50a6e4&scoped=true"
import script from "./Screenshots.vue?vue&type=script&lang=js"
export * from "./Screenshots.vue?vue&type=script&lang=js"
import style0 from "./Screenshots.vue?vue&type=style&index=0&id=2d50a6e4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d50a6e4",
  null
  
)

export default component.exports